// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root____5RO9","root__wrapper":"styles-module__root__wrapper___nG0tM","root__wrapper_item":"styles-module__root__wrapper_item___PyaRM"};
    if(module.hot) {
      // 1729151124999
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  